export enum VehicleFrequency {
  recurrent = 'RECURRENT',
  on_demand = 'ON_DEMAND'
}
